<template>
  <v-container fluid pt-0 pl-0 ml-0 mr-0 pr-0>
    <v-layout row wrap pt-0 pb-1 mt-1>
      <v-flex id="landingBanner" xs12 md6 ma-0 pa-0>
        <SplashBanner/>
      </v-flex>
      <v-flex xs12 md6 ma-0 pa-0>
        <v-card justify-center flat id="titleCard">
          <v-card-title class="pb-0">
            <v-flex xs6 justify-center text-xs-center>
              <v-img  :src="header.src" width="400" class="mx-auto"></v-img>
            </v-flex>
            <v-flex xs6 justify-center text-xs-left>
              <h2 class="headline mb-0">Get In on The Action!</h2>
              The Maroondah Cycle Training Club offers a safe, legal and friendly environment for all families to learn and enjoy the sport of motorcycle riding. We offer training sessions for members along with regular social and riding opportunities outside the clubs facilities at Kilsyth. Apply for a membership through our website and you can become apart of the community today!
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap justify-center>
              <v-flex xs12 pa-0 mt-2>
                <v-btn depressed color="success" large class="white--text" block @click="register">
                  <span>Sign In & Apply for Membership</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text pt-0>
            <v-layout row wrap text-lg-center pb-2>
              <v-flex xs4 mb-2>
                <strong>Open Hours</strong><br/>Saturday & Sunday: 12pm-5pm
              </v-flex>
              <v-flex xs4 mb-2>
                <strong>Address</strong><br/>112 Colchester Road <br/>Bayswater North Vic 3153
              </v-flex>
              <v-flex xs4 mb-2>
                <strong>Phone Number</strong><br/>(03) 9725 3076
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout ma-0 mt-0 pa-0 justify-center row wrap id="aboutSection">
      <v-flex xs12 md8 mr-0 pr-0>
        <v-card id="about" class="pa-4 mr-0">
          <v-card-title class="pb-0">
            <v-layout row wrap >
              <v-flex d-flex xs12>
                <h2 class="headline mb-0">Who Are We?</h2>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap justify-center>
              <v-flex xs12 pa-0>
                <About/>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <!-- <v-flex xs12 md4>
        <v-card id="about" depressed dark class=" sectionSide pa-4 mr-0">
           <v-card-title class="pb-0">
            <v-layout row wrap>
              <v-flex d-flex xs12>
                <h2 class="headline mb-0">Events Coming Up!</h2>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap justify-center>
              <v-flex xs12 pa-0>

              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex> -->
    </v-layout>
    <v-layout ma-4  pa-0 justify-center row wrap id="services">
      <v-flex xs12 mr-0 pr-0 mb-2 text-xs-center>
        <h1 class="white--text">What we Do</h1>
      </v-flex>
      <v-flex xs12 md8 mb-4>
        <v-layout row wrap justify-center>
          <v-flex xs12 md3 pa-2 text-xs-center>
            <v-card class="what-we-do-card">
              <v-card-title>
                <v-icon size="200" class="mx-auto blue--text">directions_bike</v-icon>
              </v-card-title>
              <v-card-text>
                <h2 class="subheading orange--text">Kids Only Bikes</h2>
                <p>This is a family motorbike club, for teaching our kids how to ride!</p>
                <p>Fun bikes up to a Honda CRF 230 model, equivalent Kawasaki or Yamaha models are also accepted.</p>
                <p>Absolutely no competition bikes are allowed.</p>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md3 pa-2 text-xs-center>
            <v-card class="what-we-do-card">
              <v-card-title>
                <v-icon size="200" class="mx-auto indigo--text">event</v-icon>
              </v-card-title>
              <v-card-text>
                <h2 class="subheading orange--text">Community</h2>
                <p>Public holidays, movie nights & birthdays. We like to celebrate special occasions together and host events for our members to get together for a good time off the track too!</p>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md3 pa-2 text-xs-center>
            <v-card class="what-we-do-card">
              <v-card-title>
                <v-icon size="200" class="mx-auto green--text">timer</v-icon>
              </v-card-title>
              <v-card-text>
                <h2 class="subheading orange--text">Regular Other Events</h2>
                <p>Held in Broadford, Victoria to further members experience</p>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout ma-0 pa-0 justify-center row wrap id="pageSection">
      <v-flex xs12 md4>
        <v-card id="contactus" depressed dark class="sectionSide pa-4 mr-0">
           <v-card-title class="pb-0">
            <v-layout row wrap>
              <v-flex xs12>
                <v-card light id="mapoverlay">
                  <v-card-title class="">
                    <v-layout row wrap ma-0 pa-0>
                      <v-flex xs12 ma-0>
                        <strong class="orange--text">Address: </strong>112 Colchester Road Bayswater North Vic 3153
                      </v-flex>
                      <v-flex xs12 ma-0>
                        <strong class="orange--text">Track Phone: </strong>9725 3076 - (only available during open hours)
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap justify-center>
              <v-flex xs12 pa-0>
                <div id='map'></div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md8 mr-0 pr-0>
        <v-card id="contact" class="pageSection pa-4 mr-0">
          <v-card-title class="pb-0 pt-0">
            <v-layout row wrap>
              <v-flex d-flex xs12>
                <h2 class="headline mb-0">Contact Us</h2>
              </v-flex>
              </v-layout>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap justify-left>
              <v-flex sm12 md3 v-for="item in contacts" pa-1 :key="item.name">
                <v-card>
                  <v-card-title class="">
                    <v-layout row wrap ma-0 pa-0>
                      <v-flex xs12 ma-0>
                        <h2 class="title contactcardpos">{{item.position}}</h2>
                      </v-flex>
                      <v-flex xs12 ma-0>
                        <h2 class="subheading">{{item.name}}</h2>
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap ma-0 pa-0>
                      <v-flex xs12 ma-0>
                        <strong class="orange--text">Email: </strong>{{item.email}}
                      </v-flex>
                      <v-flex xs12 ma-0>
                        <strong class="orange--text">Mobile: </strong>{{item.mobile}}
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout ma-0 pa-0 justify-center row wrap id="pageSection">
      <v-layout ma-4  pa-0 justify-center row wrap id="sponsors">
        <v-flex xs12 mr-0 pr-0 mb-2 text-xs-center>
          <!-- <h1 class="white--text">Our Sponsors</h1> -->
        </v-flex>
        <!-- <v-flex xs12 md8 mb-4>
          <v-layout row wrap justify-center>
            <v-flex xs12 md3 pa-2 text-xs-center ma-2 v-for="sponsor in sponsors" :key="sponsor.name" class="">
              <h1 class="headline white--text mb-2">{{sponsor.name}}</h1>
              <a :href="sponsor.link" :title="sponsor.name" class="pt-1">
                <v-img :src="sponsor.src" :title="sponsor.name"/>
              </a>
            </v-flex>
          </v-layout>
        </v-flex> -->
      </v-layout>
    </v-layout>
    <v-layout ma-0 pa-0 justify-center row wrap id="pageSection" class="white">
      <v-layout ma-4  pa-0 justify-center row wrap id="supporters">
        <v-flex xs12 mr-0 pr-0 mb-2 text-xs-center>
          <h1>Supported By</h1>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap justify-center align-center>
            <v-flex xs12 md2 v-for="support in supporters" :key="support.name" class="suppoters__wrapper">
              <!-- <h1 class="headline white--text mb-2">{{sponsor.name}}</h1> -->
              <v-img align-center :class="support.class" :src="support.src" :title="support.name"/>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import store from '@/store'
import SplashBanner from '@/components/SplashBanner'
import About from '@/components/About'
const rawContact = require('../data/contact')

export default {
  components: {
    SplashBanner,
    About
  },
  computed: {
    user () {
      return store.state.user
    },
    contacts () {
      return rawContact.contacts
    }
  },
  data () {
    return {
      header: {
        src: 'FullPicHeaderLogo.jpg'
      },
      sponsors: [
        // {
        //   name: 'All Motorcycle Xccessories',
        //   src: 'sponsor_amx_logo.jpg',
        //   link: 'https://www.amxsuperstores.com.au/'
        // },
        // {
        //   name: 'First Class Motorcycles',
        //   src: 'sponsor_fcm_logo.png',
        //   link: 'https://www.firstclassmotorcycles.com.au/'
        // },
        // {
        //   name: 'Peter Stevens Motorcycles',
        //   src: 'sponsor_psm_logo.png',
        //   link: 'https://www.peterstevens.com.au/'
        // }
      ],
      supporters: [
        {
          name: 'Motorcycling Australia',
          src: 'motorcycling_australia.png'
        },
        {
          name: 'Motorcycling Victoria',
          src: 'Motorcycling-_0004_Victoria.jpg'
        }
      ]
    }
  },
  methods: {
    register: function () {
      if (!this.user) this.$router.push('/auth')
      if (this.user) this.$router.push('/register')
      else this.$router.push('/account')
    }
  },
  mounted () {
    let latlng = [145.3047521, -37.8124827]
    if (mapboxgl) {
      mapboxgl.accessToken = 'pk.eyJ1IjoianJkbnRocnN0biIsImEiOiJjanp6NnF1OHcxdXh3M2xtbG1mNmY4bmNoIn0.nxT-XEMbtEr-7vvP737NIQ'
      var map = new mapboxgl.Map({
        container: 'map', // container id
        style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
        center: latlng, // starting position [lng, lat]
        zoom: 15 // starting zoom
      })

      new mapboxgl.Marker().setLngLat(latlng).addTo(map)
    }
  }
}
</script>

<style>
#titleCard {
  height: 100%;
}
#services h1 {
  font-weight: 400 !important;
  font-size: 2.5rem;
  margin: auto;
  padding-bottom: 0;
}
#landingHeader {
  padding-left:50px;
  font-size: 1.5rem;
  text-align: center;
  background-color: #424242;;
  box-shadow: none;
  color: white;
  margin-bottom: 20px;
}
#landingHeader h1 {
  font-weight: 400 !important;
  font-size: 2.5rem;
  margin: auto;
  padding-bottom: 0;
}
#landingHeader p{
  font-size:1.3rem;
  font-weight: 300 !important;
}
.landingContent {
  margin-top: 150px !important;
}
.trackData {
  margin-left: 10px;
  font-size: 1.5rem;
}

.sectionSide, .pageSection {
  min-height: 464px;
}

.contactcardpos {
  border-bottom: solid 2px orange;
  margin-bottom: 2px;
}

#map {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 464px;
  width:100%;
  z-index: 0;
}
#mapoverlay {
  z-index: 1;
}
.sponsorCard {
  border: solid 2px white;
  border-radius: 10px;
}

.suppoters__wrapper .v-image__image {
  max-height: 200px;
  max-width: 300px;
  background-size: contain;
  vertical-align: middle;
}

.what-we-do-card {
  height: 500px;
}

</style>
